var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('EventTeamSwiper'),_vm._v(" "),_c('BasketballMatchTabbar',{on:{"setComponent":_vm.setComponent}}),_vm._v(" "),_c(_vm.component,{tag:"component"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ef62d47","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/match/basketball/BasketBallHome.vue
// module id = null
// module chunks = 